export default "__VITE_ASSET__CDPsvFBt__"